import { Component, OnInit, EventEmitter, Output, HostListener  } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { ApiCallerService } from '../services/api-caller.service';
import {AngularFireDatabase} from 'angularfire2/database';

@Component({
  selector: 'app-teacher-quiz-view',
  templateUrl: './teacher-quiz-view.component.html',
  styleUrls: ['./teacher-quiz-view.component.css']
})
export class TeacherQuizViewComponent implements OnInit {

	@Output() startHistorical = new EventEmitter();
	@Output() resetAll = new EventEmitter();

	public previous_arrow_text = "Tillbaka till förra frågan";
	public next_arrow_text = "Vidare till nästa fråga";

	public next_text = "Till nästa fråga";
	public positive = 0;
	public negative = 0;
	public currentTrack = 0;
	public currentQuestion = 0;


	public quizOn = false;
	public timesUp = false;
	public showResult = false;
	public finalQuestion = false;

	public counter2 = 25;
	question = "";
	description = "";


	type ='PieChart';
	data = [
		['JA', 1],
		['NEJ', 2]
	];
	options = {
		id: "chart",
  		colors: ['#6CAEDF', '#4FB847'],
	 	height: 600,
	 	width: 600,
	  	backgroundColor: "transparent",
	  	legend: 'none',
	  	pieSliceText: 'label',
	  	tooltip: {textStyle:  {fontSize: 14,bold: true}}
	};
	options2 = {
		id: "chart",
  		colors: ['#6CAEDF', '#7372A9'],
	 	height: 600,
	 	width: 600,
	  	backgroundColor: "transparent",
	  	legend: 'none',
	  	pieSliceText: 'label',
	  	tooltip: {textStyle:  {fontSize: 14,bold: true}}
	};
	options3 = {
		id: "chart",
  		colors: ['#EF4E91', '#F78F1E'],
	 	height: 600,
	 	width: 600,
	  	backgroundColor: "transparent",
	  	legend: 'none',
	  	pieSliceText: 'label',
	  	tooltip: {textStyle:  {fontSize: 14,bold: true}}
	};



	@HostListener('window:beforeunload', [ '$event' ])
	  beforeUnloadHander(event) {
	  	this.db.list('/Session-'+this.service.sessionId + "/action").remove();
	    this.db.list('/Session-'+this.service.sessionId + "/action").push("reset");
	  }

	/*
		Läraren klickar på "Nästa fråga"
		Skickar notis till firebase med nuvarande frågeindex
	*/
	startQuestion(event){
		this.quizOn = true;
		// När man startar en fråga så rensar man i "action" och sätter start
		this.db.list('/Session-'+this.service.sessionId + "/action").remove();
		this.db.list('/Session-'+this.service.sessionId + "/action").push("start");
	}



	/*
		Vad som händer när countern når 0
	*/
	countDown(event){
		if (event.action == "done") {
			this.timesUp = true;
		}
	}
	/*
		När läraren klickar på "Visa klassens svar"
	*/
	presentResult(){
		this.showResult = true;
		this.timesUp = false;

		//Läser in alla svaren så det kan presenteras för läraren
		//läses in varje gång en elev klickar på ett svar så läraren blir bombad med anrop, temporär fix som rensar svaren för varje gång
		this.db.list('/Session-'+ this.service.sessionId+ "/answer").valueChanges().subscribe((answers: any) => {
		this.negative = 0;
		this.positive = 0;
		for(let row of answers){
			if (row.question == this.service.currentQuestion) 
			{
				if (row.answer == "ja") 
				{
					this.positive++;
				}
				else{
					this.negative++;
				}
			}
		}

		  this.data = [
		    ['JA', this.positive],
		    ['NEJ', this.negative]
		  ];

		});
	}

	chooseTheme(){
		
	}

	previousQuestion(){


		this.db.list('/Session-'+this.service.sessionId + "/currentAnswer").remove();
		this.finalQuestion = false;
		if (this.service.currentQuestion == 4){
			// this.service.currentQuestion--;
			this.next_arrow_text = "Vidare till historiska case";
			this.db.list('/Session-'+this.service.sessionId + "/action").remove();
			this.db.list('/Session-'+this.service.sessionId + "/action").push("historical");
			this.db.list('/Session-'+this.service.sessionId + "/question").remove();
			this.db.list('/Session-'+this.service.sessionId + "/question").push(this.service.currentQuestion);
			this.startHistorical.emit();

			return;
		}
		if (this.service.currentQuestion == 5) {
			this.service.currentQuestion--;
			this.db.list('/Session-'+this.service.sessionId + "/action").remove();
			this.db.list('/Session-'+this.service.sessionId + "/action").push("previous");
			this.db.list('/Session-'+this.service.sessionId + "/question").remove();
			this.db.list('/Session-'+this.service.sessionId + "/question").push(this.service.currentQuestion);


		}
		else{
			this.service.currentQuestion--;
			this.next_arrow_text = "Vidare till nästa fråga";
			this.currentQuestion = this.service.currentQuestion;
			this.db.list('/Session-'+this.service.sessionId + "/action").remove();
			this.db.list('/Session-'+this.service.sessionId + "/action").push("previous");
			this.db.list('/Session-'+this.service.sessionId + "/question").remove();
			this.db.list('/Session-'+this.service.sessionId + "/question").push(this.service.currentQuestion);

		}
		if (this.service.currentQuestion == 4) {
			this.previous_arrow_text = "Tillbaka till historiska case";
		}
		this.quizOn = false;
		this.showResult = false;
		this.timesUp = false;

		this.question = this.service.quizQuestions[this.service.selectedTrack][this.service.currentQuestion];
		this.description = this.service.quizQuestions[this.service.selectedTrack]["5"];
	}

	nextQuestion(){

		this.db.list('/Session-'+this.service.sessionId + "/currentAnswer").remove();
		// Om man är på fråga 3 så ska texter bytas i knapp och toplänk då det är historiska case som är nästa vy
		if (this.service.currentQuestion == 3){
			this.service.currentQuestion++;
			this.next_arrow_text = "Vidare till historiska case";
			this.db.list('/Session-'+this.service.sessionId + "/action").remove();
			this.db.list('/Session-'+this.service.sessionId + "/action").push("historical");
			this.db.list('/Session-'+this.service.sessionId + "/question").remove();
			this.db.list('/Session-'+this.service.sessionId + "/question").push(this.service.currentQuestion);
			this.startHistorical.emit();
			return;
		}

		// Öka med 1 varje gång man klickar på visa nästa fråga
		this.service.currentQuestion++;
		this.currentQuestion = this.service.currentQuestion;
		this.db.list('/Session-'+this.service.sessionId + "/question").remove();
		this.db.list('/Session-'+this.service.sessionId + "/question").push(this.service.currentQuestion);

		this.db.list('/Session-'+this.service.sessionId + "/action").remove();
		this.db.list('/Session-'+this.service.sessionId + "/action").push("next");

		this.quizOn = false;
		this.showResult = false;
		this.timesUp = false;

		this.question = this.service.quizQuestions[this.service.selectedTrack][this.service.currentQuestion];
		this.description = this.service.quizQuestions[this.service.selectedTrack]["5"];




		if (this.service.currentQuestion == 3){
			this.next_text = "Till historiska case";
			this.next_arrow_text = "Vidare till historiska case";
		}

		// På fråga fem ska utseendet ändras
		if (this.service.currentQuestion == 5) {
			this.finalQuestion = true;
			this.currentQuestion = this.service.currentQuestion;
			this.currentTrack = this.service.selectedTrack;
			this.previous_arrow_text = "Tillbaka till förra frågan";
		}
	}


	reset(){
		this.db.list('/Session-'+this.service.sessionId + "/action").remove();
		this.db.list('/Session-'+this.service.sessionId + "/action").push("reset");
		this.resetAll.emit();
	}



  constructor(
  	private service: ApiCallerService,
  	private db: AngularFireDatabase) { }

	/*
		När vyn först presenteras så ska den första frågan presenteras
	*/
	ngOnInit() {
		this.currentQuestion = this.service.currentQuestion;

		if (this.service.currentQuestion == 3) {
			this.next_arrow_text = "Vidare till historiska case";
		}


		if (this.service.currentQuestion == 4) {
			this.next_arrow_text = "Till avslut";
			this.next_text = "Till avslut";
			this.previous_arrow_text = "Tillbaka till historiska case";
		}
		

		this.question = this.service.quizQuestions[this.service.selectedTrack][this.service.currentQuestion];


	


	}

}
